import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router";
import VueMeta from 'vue-meta';
import moment from "moment-jalaali";
import * as  VueGoogleMaps from 'vue2-google-maps'
import VueGeolocation from 'vue-browser-geolocation'

import VuePreferences, {preference} from 'vue-preferences'


import './registerServiceWorker'

import "@/assets/styles/master.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/brands.css";
import "@/assets/styles/light.min.css";
import "@/assets/styles/solid.min.css";
import "@/assets/styles/vuetify.css";

Vue.prototype.$baseUrl = "https://pwa.shahkareghalam.com";
//Vue.prototype.$baseUrl = "http://localhost:59474";

Vue.config.productionTip = false

Vue.prototype.$priceHistory = null;

Vue.use(VuePreferences, {
    storage: window.localStorage,
    namespace: 'shahkareghalam'
});
Vue.use(VueMeta);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCDfnJg1u4elSPk5-bFPHlKvF62D3YdgtU',
        libraries: '',
        language: 'fa'
    }
});
Vue.use(VueGeolocation)
Vue.prototype.$setUserData = function (mobile, activeCode, token) {
    preference('userData', {defaultValue: '{"mobile":"", "activeCode":"","token":""}'})
        .set(JSON.stringify({'mobile': mobile, 'activeCode': activeCode, 'token': token}));
};
Vue.prototype.$getUserData = function () {
    return JSON.parse(preference('userData',
        {defaultValue: '{"mobile":"", "activeCode":"","token":""}'}).get());
};

Vue.prototype.$setScrollPos = function (scrollPos) {
    preference('scrollPos', {defaultValue: 0}).set(scrollPos);
};

Vue.prototype.$getScrollPos = function () {
    return preference('scrollPos', {defaultValue: 0}).get();
};

Vue.prototype.$typeSettings = [
    {
        id: 0,
        name: 'NewProductsSection'
    },
    {
        id: 1,
        name: 'SeasonalProductSection'
    },
    {
        id: 2,
        name: 'MostBoughtProductSection'
    },
    {
        id: 3,
        name: 'DiscountedProductSection'
    },
];

Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null && httpUrl !== undefined) {
        return httpUrl.replace('http://', 'https://');
    }
};
Vue.prototype.$computingPriceOffer = function (price, off) {
    let priceNum = price;

    if (typeof priceNum !== "number") {
        priceNum = price.replace(",", "");
    }
    return this.$numberWithCommas(parseInt(priceNum) - (parseInt(priceNum) * (off / 100)));
};
Vue.prototype.$numberWithCommas = function (x) {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};
Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jMM/jDD')
}
Vue.prototype.$currentBagData = []
Vue.prototype.$openLink = function (url) {
    /*var newWindow = window.open("about:blank", "_blank");
    newWindow.location = url;*/
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    // a.download = <your_fileName>;
    a.click();
    document.body.removeChild(a);
}

Vue.prototype.$moment = function (date) {
    return moment(date).format('jYYYY/jM/jD');
};
Vue.prototype.$seoUrl = "https://www.shahkareghalam.com";
Vue.prototype.$keywords = 'انتشارات, ناشر کتاب, شاهکار قلم, انتشارات شاهکار قلم';

Vue.prototype.$description = window.projectName + "02166969837";
Vue.prototype.$defaultImage = "https://www.shahkareghalam.com/img/icons/android-chrome-maskable-512x512.png"

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
